import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "../store/state/app.state";

export class PageInfo {
  description: string;
  group_name: string;
  groupid: number;
  id: number;
  islive: boolean;
  laburl: string;
  name: string;
  pagename: string;
  parameters: string;
  url: string;
  isSelected: boolean;
  paramsobj: {};

  constructor(init?: Partial<PageInfo>) {
    Object.assign(this, init);
  }
}

export class LabsUser {
  is_lab_access: boolean;
  is_apitutorial_access: boolean;
  is_internal: boolean;
  is_initialize: boolean;
  is_lab_menu_access: boolean;
  is_data_check: any = {};
  is_sellside: boolean;
  constructor(init?: Partial<LabsUser>) {
    Object.assign(this, init);
  }
}

export enum LabAccess {
  EA = "EA",
  EA_AND_LABS = "Labs & EA",
  NONE = "None",
}

@Injectable({
  providedIn: "root",
})
export class LabsPageService {
  apiEP = `${window.apiUrl}/analytics_pages`;
  public tutorialPages: Array<any> = [];
  public labsPagesParams: any = {};
  public isLabAccess = true;
  public labsUser: LabsUser;
  public introductionPageName = "introduction";
  public recentlyNavigatedPage = "";

  public checkCompleteSubject = new Subject<any>();

  constructor(private http: HttpClient) {
    this.labsUser = new LabsUser({
      is_initialize: false,
      is_lab_access: false,
      is_lab_menu_access: false,
    });
  }

  async initLabsUser(store: Store<AppState>) {
    if (!this.labsUser.is_initialize) {
      store
        .select(stateGetter("globalHeader", "menuOption"))
        .subscribe((data: any) => {
          if (data.length > 0) {
            this.labsUser.is_data_check.menuOption = true;
            this.labsUser.is_initialize = true;
            if (data.some((x) => x.name === "Labs")) {
              this.labsUser.is_lab_access = true;
            }
            if (data.some((x) => x.name === "API Tutorials")) {
              this.labsUser.is_apitutorial_access = true;
            }
            this.checkCompleteSubject.next();
          }
        });

      store
        .select(stateGetter("globalHeader", "globalSettings"))
        .subscribe((data) => {
          if (Object.keys(data).length > 0) {
            this.labsUser.is_data_check.globalSettings = true;
            this.labsUser.is_lab_menu_access = data.show_labs_secondarymenu;
            this.labsUser.is_sellside = data.isSellside;
            this.checkCompleteSubject.next();
          }
        });
    } else {
      this.checkCompleteSubject.next();
    }
  }

  getLabsUrls(queryParams, params, type): Observable<any> {
    if (String(queryParams).length > 0 && String(queryParams).includes("?")) {
      queryParams = `${queryParams}&group_type=${type}`;
    } else {
      queryParams = `?group_type=${type}`;
    }
    return this.http.post<any>(
      `${this.apiEP}/get_reports${queryParams}`,
      params,
    );
  }

  getLabsPages(queryParams): Observable<any> {
    return this.http.get<any>(`${this.apiEP}/get_labs_page${queryParams}`);
  }

  getLabsData(): Observable<any> {
    return this.http.get<any>(`${this.apiEP}/get_labsdata`);
  }

  updateUserAccess(userAccess: LabAccess): Observable<any> {
    const params = new HttpParams().append("accesslevel", userAccess);
    return this.http.get<any>(`${this.apiEP}/update_useraccess`, { params });
  }

  getReportList(labsPages) {
    const reportList = [];
    const clone = Object.assign({}, labsPages);
    const keys = Object.keys(clone);
    for (let index = 0; index < keys.length; index++) {
      for (const item of clone[keys[index]]) {
        reportList.push(item);
      }
    }
    return reportList;
  }

  updateQueryStringParameter(uri, key, value) {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
    const separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, `$1${encodeURI(key)}=${encodeURI(value)}$2`);
    }

    return `${uri + separator + encodeURI(key)}=${encodeURI(value)}`;
  }
}
